/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import useGeniatech from '../../../../../../../hooks/shared/geniatech/useGeniatech';
import GeniatechContext from '../../../../../../../context/GeniatechContext';
import { TOWER_URL } from '../api/PerformanceUrl';
import helpers from '../../../../../../../utils/helpers';

const PerformanceProvider = ({ children }) => {
  const { data, loading, pages, search, searchData, onChange, searchStatus, reset, fetched } = useGeniatech(
    {
      action: 'get_devices_performance',
      offset: '0',
      limit: '100',
      start_time: helpers.currentDate(),
      stop_time: helpers.currentDate(),
    },
    `${TOWER_URL}`,
  );
  return (
    <GeniatechContext.Provider
      value={{
        data,
        loading,
        search,
        searchData,
        pages,
        onChange,
        searchStatus,
        reset,
        fetched,
      }}
    >
      {children}
    </GeniatechContext.Provider>
  );
};
export default PerformanceProvider;
